import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDeclineReasons,
  updateDeclineReasons,
} from "../../redux/actions/declineReasonSettings";
import Loader from "../Loader";
import { toast } from "react-toastify";

const defaultValues = {
  invalidEmail: "",
  notAnsweredAllQuestions: "",
  notPreApproved: "",
};

const validateForm = (values) => {
  if (!values.invalidEmail.trim()) {
    return {
      pass: false,
      errorMsg: "Please enter decline reason for Invalid Email!",
    };
  } else if (!values.notAnsweredAllQuestions.trim()) {
    return {
      pass: false,
      errorMsg: "Please enter decline reason for Didn’t answer all questions!",
    };
  } else if (!values.notPreApproved.trim()) {
    return {
      pass: false,
      errorMsg: "Please enter decline reason for Not Pre-approved!",
    };
  } else {
    return {
      pass: true,
    };
  }
};

const DeclineReasons = ({ userInfo }) => {
  const [reasons, setReasons] = useState(defaultValues);
  const dispatch = useDispatch();
  const declineReasonSettings = useSelector((state) => state.declineReasons);
  const { loading, declineReasons } = declineReasonSettings;
  useEffect(() => {
    dispatch(getDeclineReasons());
  }, [dispatch]);

  useEffect(() => {
    if (declineReasons) {
      setReasons({
        invalidEmail: declineReasons?.invalidEmail || "",
        notAnsweredAllQuestions: declineReasons?.notAnsweredAllQuestions || "",
        notPreApproved: declineReasons?.notPreApproved || "",
      });
    }
  }, [declineReasons]);

  const handleSubmit = () => {
    if (userInfo?.planNo < 5) {
      toast.info(`Please upgrade your account to use this feature!`);
      return true;
    }
    const validationRes = validateForm(reasons);
    if (validationRes.pass) {
      dispatch(updateDeclineReasons(reasons));
    } else {
      toast.error(validationRes.errorMsg);
      return false;
    }
  };

  return (
    <div id="tab-3" className="tab-content">
      {loading && <Loader />}
      <div className="tableInfo">
        <div className="listTables">
          <div className="indReasons">
            <p>Invalid email provided</p>
            <textarea
              className="reasonTextareas"
              placeholder="Enter reason for Invalid email provided"
              value={reasons.invalidEmail}
              onChange={(e) => {
                setReasons({ ...reasons, invalidEmail: e.target.value });
              }}
            />
          </div>

          <div className="indReasons">
            <p>Didn’t answer all questions</p>
            <textarea
              className="reasonTextareas"
              placeholder="Enter reason for Didn’t answer all questions"
              value={reasons.notAnsweredAllQuestions}
              onChange={(e) => {
                setReasons({
                  ...reasons,
                  notAnsweredAllQuestions: e.target.value,
                });
              }}
            />
          </div>

          <div className="indReasons">
            <p>Not pre-approved</p>
            <textarea
              className="reasonTextareas"
              placeholder="Enter reason for Not pre-approved"
              value={reasons.notPreApproved}
              onChange={(e) => {
                setReasons({ ...reasons, notPreApproved: e.target.value });
              }}
            />
          </div>
          <div className="indReasons">
            <button
              className="createButton gmNewBtn Lists"
              onClick={handleSubmit}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeclineReasons;
